import * as types from './types';
import Vue from 'vue'

export default {
    [types.MUTATE_UPDATE_ZIPCODE]: (state, payload) => {
        //Update zipcode
        state.VuexZipcode = payload;
    },
    [types.MUTATE_UPDATE_RENTALCONTAINERSLIST]: (state, payload) => {
        //Update products list
        state.VuexRentalContainersList = payload;
    },
    [types.MUTATE_UPDATE_DOORDIRECTION]: (state, payload) => {
        //Update door direction answer
        state.VuexPredelivery.doordirection = payload;
    },
    [types.MUTATE_UPDATE_DELIVERYSPACE]: (state, payload) => {
        //Update delivery space answer
        state.VuexPredelivery.deliveryspace = payload;
    },
    [types.MUTATE_UPDATE_CONTAINERCONDITION]: (state, payload) => {
        //Update container condition answer
        state.VuexPredelivery.containercondition = payload;
    },
    [types.MUTATE_UPDATE_TWOMONTHS]: (state, payload) => {
        //Update two months agreement answer
        state.VuexPredelivery.twomonths = payload;
    },
    [types.MUTATE_UPDATE_DELIVERYINSTRUCTIONS]: (state, payload) => {
        //Update additional comments
        state.VuexPredelivery.deliveryinstructions = payload;
    },
    [types.MUTATE_UPDATE_DELIVERYCONTACTNAME]: (state, payload) => {
        //Update delivery contact name
        state.VuexPredelivery.deliveryname = payload;
    },
    [types.MUTATE_UPDATE_DELIVERYCONTACTPHONE]: (state, payload) => {
        //Update delivery contact phone
        state.VuexPredelivery.deliveryphone = payload;
    },
    [types.MUTATE_UPDATE_CARTLINEITEM]: (state, payload) => {
        //Since the cart will only have zero or one item at any point of renting experience
        Vue.set(state.VuexCartItem, 0, payload);
    },
    [types.MUTATE_UPDATE_EMPTYCART]: (state) => {
        //Make the cart empty        
        state.VuexCartItem = [];
    },    
    [types.MUTATE_UPDATE_UNACCEPTABLEDATES]: (state, payload) => {
        //Update dates clients dont want containers to be delivered.
        state.VuexPredelivery.nonacceptabledates = payload;
    },    
    [types.MUTATAE_UPDATE_TERMSNCONDITIONS]: (state, payload) => {
        //Update Paywhirl Customer Email-ID
        state.terms_conditions = payload;
    },
    [types.MUTATE_UPDATE_PREDELIVERYANSWERS]: (state, payload) => {
        //Update entire Profile Questions Answers
        state.VuexPredelivery = payload;
    },
    [types.MUTATE_UPDATE_PREDELIVERYANSWERSDEFAULT]: (state) => {
        //Set all the values to default except for name and phone number.
        state.VuexPredelivery.doordirection = null;
        state.VuexPredelivery.deliveryspace = null;
        state.VuexPredelivery.containercondition = null;
        state.VuexPredelivery.twomonths = null;
        state.VuexPredelivery.deliveryinstructions = '';        
        state.VuexPredelivery.nonacceptabledates = [];
        state.VuexPredelivery.movecontainers = null;
        state.VuexPredelivery.rentalsduration = '';
        state.VuexPredelivery.deliverysurfacetype = '';       
    },
    [types.MUTATE_UPDATE_MOVECONTAINERS]: (state, payload) => {
        //Update move loaded containers answer
        state.VuexPredelivery.movecontainers = payload;
    },
    [types.MUTATE_UPDATE_RENTALSDURATION]: (state, payload) => {
        //Update rentals duration answer
        state.VuexPredelivery.rentalsduration = payload;
    },
    [types.MUTATE_UPDATE_DELIVERYSURFACETYPE]: (state, payload) => {
        //Update delivery surface answer - 'hard/soft'
        state.VuexPredelivery.deliverysurfacetype = payload;
    },
    [types.MUTATE_UPDATE_SOFTSURFACEACKNOWLEDGE]: (state, payload) => {
        //Update  SOFT SURFACE acknowledgement
        state.VuexPredelivery.softSurfaceAcknowledge = payload;
    },
    [types.MUTATE_UPDATE_COUNTRY_CODE]: (state, payload) => {
        //Update COUNTRY CODE
        state.country_code = payload;
    },
};